export const UPDATE_PAGE_DATA = "KPI_LEARNING_DETAILS_UPDATE_PAGE_DATA";
export const UPDATE_FILTER_SELECTED_VALUES =
  "KPI_LEARNING_DETAILS_UPDATE_FILTER_SELECTED_VALUES";
export const UPDATE_FILTER_AVAILABLE_VALUES =
  "KPI_LEARNING_DETAILS_UPDATE_FILTER_AVAILABLE_VALUES";
export const RESET_LEARNING_DATA = "KPI_LEARNING_DETAILS_RESET_LEARNING_DATA";
export const UPDATE_ALL_LESSONS = "UPDATE_ALL_LESSONS";
